module.exports = __webpack_public_path__ + "static/media/02-chs.2f962d05.png";